import { useAuth } from '../contexts/AuthContext';
import { usePermissionsContext } from '../contexts/PermissionsContext';

export const usePermissions = (resource) => {
    const { user } = useAuth();
    const { permissions, loading } = usePermissionsContext();

    const checkPermission = (action) => {
        if (loading || !permissions || !user) {
            return false;
        }

        // Superusers have all permissions
        if (user.is_superuser) {
            return true;
        }

        const role = user.role_in_organization;
        if (!role) {
            return false;
        }

        const resourcePermissions = permissions[resource];
        if (!resourcePermissions) {
            return false;
        }

        const rolePermissions = resourcePermissions[role];
        if (!rolePermissions) {
            return false;
        }

        return rolePermissions.includes(action);
    };

    // For convenience, return booleans for standard CRUD operations
    const canCreate = checkPermission('create');
    const canRead = checkPermission('read');
    const canUpdate = checkPermission('update');
    const canDelete = checkPermission('delete');

    return { 
        hasPermission: checkPermission, 
        canCreate, 
        canRead, 
        canUpdate, 
        canDelete, 
        loading 
    };
};
